module.exports = __webpack_public_path__ + "static/img/sedan-yellow.7a01710.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-yellow.svg
// module id = j+TR
// module chunks = 74